<template>
  <div>
    <app-header class="topHeader" main />
    <div class="bottomBody">
      <div class="sidebarWrapper">
        <qs-scrollbar style="height: 100%">
          <el-menu>
            <template v-for="(item, index) in navList">
              <el-submenu v-if="item.children.length > 1" :key="index" index>
                <template slot="title">
                  <svg-icon :iconClass="getIcon(item.resIcon)"></svg-icon>
                  <span>{{ $t("sideMenu." + item.name) }}</span>
                </template>
                <el-menu-item
                  v-for="child in item.children"
                  :key="child.name"
                  @click="clickNav(child)"
                >
                  <svg-icon :iconClass="getIcon(child.icon)"></svg-icon>
                  {{ $t("sideMenu." + child.name) }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item
                v-else
                :key="index"
                @click="clickNav(item.children[0])"
              >
                <svg-icon
                  :iconClass="getIcon(item.children[0].icon)"
                ></svg-icon>
                {{ $t("sideMenu." + item.children[0].name) }}
              </el-menu-item>
            </template>
          </el-menu>
        </qs-scrollbar>
      </div>
      <div class="qs-view_wrapper">
        <div style="margin: 10px; height: calc(100% - 20px); overflow: auto">
          <div class="collectionNav">
            <div class="myCollection">{{ $t("common.myCollection") }}</div>
            <div class="settingIcon" @click="clickSetting">
              <i class="el-icon-s-tools"></i>
            </div>
            <div>
              <ul>
                <li
                  v-for="(item, index) in myCollectionList"
                  :key="index"
                  class="collectionItem"
                  @click="clickFavorite(item)"
                >
                  <svg-icon :iconClass="getIcon(item.resIcon)"></svg-icon>
                  <span>{{ item.i18nDesc }}</span>
                </li>
                <li
                  v-if="myCollectionList.length < 12"
                  class="collectionItem addMore"
                  @click="clickSetting"
                >
                  <div class="addIcon">+</div>
                  <div>{{ $t("common.addtoCollection") }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="news">
            <div class="myCollection">{{ $t("common.notice") }}</div>
          </div>
        </div>
      </div>
    </div>

    <el-drawer
      :title="$t('common.myCollection')"
      :visible.sync="showDrawer"
      :direction="direction"
      :before-close="handleClose"
      :modal="false"
      modal-append-to-body
      :show-close="false"
      :wrapperClosable="false"
      size="660px"
    >
      <!-- <i class="el-icon-error closeDrawer"></i> -->
      <div class="collectedTitle">
        <span>{{ $t("common.collectedList") }}</span>
      </div>
      <div class="distance">
        <el-button
          @click="addCollection"
          icon="el-icon-plus"
          type="primary"
          size="small"
          :disabled="tableData1.length >= maxLength"
        >
          {{ $t("common.add") }}
        </el-button>
        <el-button
          icon="el-icon-delete"
          type="danger"
          size="small"
          plain
          @click="removeFavorites"
        >
          {{ $t("common.delete") }}
        </el-button>
      </div>
      <div>
        <el-table
          ref="mainTable1"
          :data="tableData1"
          stripe
          style="width: 100%"
          @selection-change="handleSelectionChange1"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column prop="i18nDesc" :label="$t('common.functionName')">
          </el-table-column>
          <el-table-column prop="action" :label="$t('common.action')">
            <template slot-scope="scope">
              <span class="removeTitle" @click="removeOne(scope.row)">{{
                $t("common.remove")
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: center; margin-top: 10px">
        <!-- <el-button type="primary" @click="firm">确认</el-button> -->
        <el-button @click="handleClose">{{ $t("common.cancel") }}</el-button>
      </div>
    </el-drawer>
    <el-dialog
      :title="$t('common.add')"
      :visible.sync="dialogTableVisible"
      :modal="false"
      modal-append-to-body
      height="60vh"
    >
      <div class="dialogIntro">{{ $t("common.selectGrouptoAdd") }}</div>
      <el-form ref="form" :model="searchForm">
        <el-form-item label="">
          <el-input
            v-model="searchForm.name"
            :placeholder="$t('common.functionNameQuery')"
            style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" icon="el-icon-search" @click="addCollection()">
        {{ $t("common.query") }}
      </el-button>
      <el-table
        ref="mainTable2"
        :data="tableData2"
        stripe
        style="width: 100%"
        height="300px"
        @selection-change="handleSelectionChange2"
      >
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column
          prop="route"
          :label="$t('common.primaryDirectory')"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="i18nDesc" :label="$t('common.functionName')">
        </el-table-column>
      </el-table>
      <div class="dialogBottom">
        <el-button
          type="primary"
          :disabled="selectedItems2.length == 0"
          class="authfr"
          @click="confirmAdd()"
          style="margin-left: 10px"
        >
          {{ $t("common.add") }}
        </el-button>
        <el-button class="authfr" @click="cancelAdd">
          {{ $t("common.cancel") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
  <!-- <Header /> -->
</template>

<script>
import SvgIcon from "@/components/SvgIcon";
import { getFavorites, addFavorites, delFavorite } from "@/api/main.js";
import AppHeader from "@/layout/components/header.vue";
import QsScrollbar from "@/components/qs-scrollbar";
export default {
  components: { SvgIcon, AppHeader, QsScrollbar },
  data() {
    return {
      selectedItems1: [],
      selectedItems2: [],
      currentRemove: [],
      maxLength: 12,
      formInline: {},
      searchForm: {
        name: "",
      },
      direction: "rtl",
      tableData2: [],
      dialogTableVisible: false,
      false: false,
      tableData1: [],
      showDrawer: false,
      date: "",
      myCollectionList: [],
    };
  },
  mounted() {
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    _this.date = this.dateFormat("YYYY-mm-dd HH:MM", new Date());
    this.timer = setInterval(() => {
      _this.date = this.dateFormat("YYYY-mm-dd HH:MM", new Date()); // 修改数据date
    }, 30000);
    this.queryFavorites();
  },
  computed: {
    navList() {
      // return this.$store.getters.auth.routes;
      return JSON.parse(sessionStorage.getItem("routes"));
    },
  },
  methods: {
    logout() {
      //将上次登录信息清除
      this.$store.commit("login/RESET_STATE");
      //清除本地存储
      localStorage.clear();
      sessionStorage.clear();
      //令牌过期,令牌格式错误，未登录
      // this.$router.push("/login");
      location.href = "/login";
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    clickFavorite(item) {
      //二级路由
      this.$store.commit("login/SET_CURRENTROUTE", {
        name: item.resCode,
        flag: true,
      });
      this.$router.push({ name: item.resCode });
    },
    clickNav(item) {
      localStorage.setItem("currentRoute", JSON.stringify(item.children));
      localStorage.removeItem("SET_ROLES")
      //检查用户权限，跳转页面
      location.href = item.path;
    },
    cancelAdd() {
      this.dialogTableVisible = false;
      this.searchForm.name = "";
    },
    handleSelectionChange1(rows) {
      this.currentRemove = null;
      this.selectedItems1 = rows;
    },
    handleSelectionChange2(rows) {
      this.selectedItems2 = rows;
    },
    removeOne(item) {
      //弹框二次确认
      this.currentRemove = item;
      this.removeFavorites();
    },
    removeFavorites() {
      //弹框二次确认
      // this.$qsMessage.warn(callBack)
      const h = this.$createElement;
      this.$msgbox({
        title: this.$t("common.msg"),
        message: h("p", null, [
          h("span", null, this.$t("common.confirmDelete")),
          h(
            "span",
            { style: "color: #FEAA09;" },
            this.$t("common.unrecoverable")
          ),
          h("span", null, "！"),
        ]),
        customClass: "yellowType",
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.confirmRemove();
            done();
          } else {
            this.dialogTableVisible = false;
            done();
          }
        },
      }).then(() => {});
    },
    confirmRemove() {
      let arr = [];
      if (this.currentRemove) {
        //单选
        arr.push(this.currentRemove.id);
      } else {
        this.selectedItems1.forEach((item) => {
          //多选
          arr.push(item.id);
        });
      }
      let data = {
        ids: arr,
      };
      delFavorite(data).then((res) => {
        //删除成功就刷新抽屉
        if (res.code == "AUTH_000000") {
          this.dialogTableVisible = false;
          this.queryFavorites();
          this.$refs.mainTable1.clearSelection();
        }
      });
    },
    confirmAdd() {
      if (
        this.selectedItems2.length + this.tableData1.length >
        this.maxLength
      ) {
        this.$message({
          message: this.$t("common.maxFunction").replace("N", this.maxLength),
          type: "warning",
        });
        return;
      }
      let arr = [];
      this.selectedItems2.forEach((item) => {
        arr.push(item.id);
      });
      let data = {
        ids: arr,
      };
      addFavorites(data).then((res) => {
        //关闭对话框，提示后刷新抽屉
        if (res.code == "AUTH_000000") {
          this.dialogTableVisible = false;
          this.queryFavorites();
        }
      });
    },
    queryFavorites() {
      let data = {
        hasCollected: "Y", // 是否已收藏 Y-是 N-否
        vagueParam: "", // 查询关键字 资源编码 or 资源名称
      };
      getFavorites(data).then((res) => {
        this.myCollectionList = res.data;
        this.tableData1 = this.myCollectionList;
      });
    },
    handleClose() {
      this.showDrawer = false;
    },
    clickSetting() {
      this.showDrawer = true;
    },
    addCollection() {
      //打开新增对话框
      this.dialogTableVisible = true;
      let data = {
        hasCollected: "N", // 是否已收藏 Y-是 N-否
      };
      getFavorites(data).then((res) => {
        if (this.searchForm.name) {
          this.tableData2 = res.data.filter((item) => {
            const reg = new RegExp(this.searchForm.name, "i");
            if (reg.test(item.i18nDesc)) {
              return true;
            }
            return false;
          });
        } else {
          this.tableData2 = res.data;
        }
      });
    },
    getIcon(icon) {
      return icon || "default";
    },
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
  },
};
</script>
<style lang="less" scoped>
.bottomContent {
  background-color: #f5f7fa;
  padding-top: 1px;
  margin-top: 60px;
  height: calc(100vh - 61px);
  width: 100%;
}
.leftContent {
  width: 260px;
  background-color: white;
  float: left;
  height: 100%;
}
.rightContent {
  width: calc(100vw - 281px);
  margin: 10px;
  float: right;
  height: calc(100% - 20px);
}
.collectionNav {
  border-radius: 4px;
  background-color: white;
  height: 320px;
  padding: 20px;
  width: calc(100% - 40px);
  position: relative;
}
.news {
  border-radius: 4px;
  background-color: white;
  margin-top: 10px;
  padding: 20px;
  width: calc(100% - 40px);
  height: calc(100vh - 491px);
}
.myCollection {
  font-size: 16px;
  color: #343c6a;
  font-weight: 600;
  margin-bottom: 20px;
}
.collectionItem {
  float: left;
  height: 55px;
  line-height: 55px;
  padding-left: 25px;
  width: calc(33vw - 210px);
  box-shadow: 0px 1px 3px rgb(0 0 0 / 25%);
  margin-right: 50px;
  min-width: 250px;
  font-size: 16px;
  color: #222153;
  font-weight: 400;
  cursor: pointer;
  margin-bottom: 20px;
}
.collectionItem:hover {
  background: #f4f4f4;
  border-radius: 3px;
}
.addMore {
  border: 1px dashed #c0c3cc;
  width: calc(33vw - 185px);
  font-size: 12px;
  color: #c0c3cc;
  font-weight: 400;
  line-height: 27px;
  text-align: center;
  padding-left: 0;
}
.addMore:hover {
  background: #fff;
}
.addIcon {
  font-size: 24px;
}
.navItem {
  height: 50px;
  line-height: 50px;
  text-align: left;
  padding-left: 25px;
  cursor: pointer;
  font-size: 14px;
  color: #212153;
  font-weight: 400;
  i {
    color: #212153;
  }
}
.navItem:hover {
  background-color: #212153;
  color: white;
  i {
    color: white;
  }
}
.logo {
  height: 24px;
  width: 81px;
  display: inline-block;
  background: url("../../static/images/login/logo.png");
  background-position: right;
  margin-top: 18px;
  margin-left: 27px;
}
.openMore {
  display: inline-block;
  height: 30px;
  width: 20px;
  line-height: 4px;
  margin-left: 107px;
  cursor: pointer;
}
.openMore > span {
  width: 18px;
  height: 2px;
  display: inline-block;
  margin-bottom: 3px;
  background-color: #262559;
}
.currentTime {
  margin-left: 40px;
  font-size: 12px;
  color: #303133;
  font-weight: 400;
}
.margin11 {
  margin-right: 11px;
}
.settingIcon {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}
.closeDrawer {
  position: absolute;
  top: 24px;
  left: 0px;
  z-index: 999;
}
::v-deep .el-drawer__header > span {
  font-size: 14px;
  color: #303133;
  line-height: 16px;
  font-weight: 600;
}
::v-deep .el-drawer__header {
  margin-bottom: 0px;
}
.collectedTitle {
  font-size: 14px;
  color: #343c6a;
  font-weight: 400;
}
::v-deep .el-form-item__content {
  display: inline-block !important;
}
::v-deep .el-form {
  display: inline-block !important;
}
.dialogIntro {
  height: 26px;
  line-height: 17px;
}
.dialogBottom {
  margin-top: 10px;
  overflow: hidden;
  height: 40px;
}
.removeTitle {
  font-size: 14px;
  color: #ff0000;
  text-align: left;
  font-weight: 400;
  cursor: pointer;
}
.logoutButton {
  margin-top: 10px;
  margin-right: 20px;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #343c6a;
  border-color: #343c6a;
}
.distance {
  margin: 10px 0;
}
</style>
